function formatGameName(gameName: string) {
  return gameName
    .replace(/&/g, 'and') // replace & with 'and'
    .replace(/[!@#$%^&*()_+=[\]{};':"\\|,.<>/?`~]/g, '') // remove unwanted special chars
    .replace(/\s+/g, '-') // replace spaces with -
    .toLowerCase()
}
export default formatGameName
